import { useEffect, useState } from "react";
import { Button, Col, Drawer, Form, Row, Select } from "antd";
import { StoreRequisitionContext } from "context/StoreRequisitionContext/StoreRequisitionContextProvider";
import { useContext } from "react";

const { Option } = Select;

const StyleAddDrawer = ({ open, onClose, onSave, editData }) => {
  const [form] = Form.useForm();
  const { styleList } = useContext(StoreRequisitionContext);
  const [selectedStyle, setSelectedStyle] = useState(null);

  useEffect(() => {
    if (open && editData) {
      form.setFieldsValue({
        style_id: editData.style_id,
        sales_contract_id: editData.sales_contract_id,
        buying_office_id: editData.buying_office_id,
        po_map_id: editData.po_map_id,
      });
      const style = styleList.find((s) => s.id === editData.style_id);
      if (style) setSelectedStyle(style);
    } else if (open) {
      form.resetFields();
      setSelectedStyle(null);
    }
  }, [open, editData, form, styleList]);

  const handleStyleSelect = (styleId) => {
    const style = styleList.find((s) => s.id === styleId);
    setSelectedStyle(style || null);
    if (style) {
      form.setFieldsValue({
        sales_contract_id: style.sales_contract?.id,
        buying_office_id: style.buying_office_info?.id,
        po_map_id: undefined,
      });
    }
  };

  const handleSubmit = () => {
    form.validateFields().then((values) => {
      const style = styleList.find((s) => s.id === values.style_id);
      const poMap = style?.purchase_order_maps?.find(
        (po) => po.id === values.po_map_id,
      );
      onSave({
        ...editData,
        style_id: values.style_id,
        style_no: style?.style_no,
        sales_contract_id: values.sales_contract_id,
        sales_contract_no: style?.sales_contract?.reference_no,
        buying_office_id: values.buying_office_id,
        buying_office_name: style?.buying_office_info?.name,
        po_map_id: values.po_map_id,
        original_po: poMap?.original_po,
        sub_style_map: style?.sub_style_map || [],
        items: editData?.items || [],
      });
      form.resetFields();
      setSelectedStyle(null);
      onClose();
    });
  };

  const poOptions = selectedStyle?.purchase_order_maps || [];

  return (
    <Drawer
      title={editData ? "Edit Style" : "Add Style"}
      open={open}
      onClose={onClose}
      width={520}
      maskClosable={false}
      destroyOnClose
      extra={
        <Button type="primary" size="small" onClick={handleSubmit}>
          Save
        </Button>
      }
    >
      <Form form={form} layout="vertical" size="small">
        <Row gutter={12}>
          <Col span={24}>
            <Form.Item
              label="Style"
              name="style_id"
              rules={[{ required: true, message: "Style is required" }]}
            >
              <Select
                showSearch
                placeholder="Select style"
                optionFilterProp="children"
                onChange={handleStyleSelect}
              >
                {styleList.map((style) => (
                  <Option key={style.id} value={style.id}>
                    {style.style_no}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label="Sales Contract" name="sales_contract_id">
              <Select disabled placeholder="Auto populated">
                {selectedStyle?.sales_contract && (
                  <Option value={selectedStyle.sales_contract.id}>
                    {selectedStyle.sales_contract.reference_no}
                  </Option>
                )}
              </Select>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label="Buying Office" name="buying_office_id">
              <Select disabled placeholder="Auto populated">
                {selectedStyle?.buying_office_info && (
                  <Option value={selectedStyle.buying_office_info.id}>
                    {selectedStyle.buying_office_info.name}
                  </Option>
                )}
              </Select>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label="PO" name="po_map_id">
              <Select
                showSearch
                placeholder="Select PO"
                optionFilterProp="children"
                allowClear
              >
                {poOptions.map((po) => (
                  <Option key={po.id} value={po.id}>
                    {po.original_po}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Drawer>
  );
};

export default StyleAddDrawer;
